#import "../../../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"
query MovementTravelerEmailStatus($id: UUID!) {
  travelAuthorization(id: $id) {
    id
    movementOrder {
     movementTravelers(orderBy: TRAVELER_NAME_ASC) {
        nodes {
          id
          _rowTimestamp
          travelerName
             entityDocumentId
          _emailDocument {
            ...EmailDocumentFields
          }
          emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
            nodes {
              ...EntityEmailDocumentsFields
            }
          }
        }
      }
    }
  }
}
